// 複製文字用
import { useDispatch } from "react-redux";
import { setCopyHint, setHintText } from "@/slices/popSlice";

export default function useCopy() {
  const dispatch = useDispatch();

  const copy = async (text, type = "COPY_LINK") => {
    dispatch(setHintText(type));
    dispatch(setCopyHint(true));
    await navigator.clipboard.writeText(text);
  };

  return copy;
}
